@if (isLoaded) {
    <div class="trading-sessions-component">
        <h1>Trading sessions</h1>

        <div id="filter-accordion">
            <div class="card">
                <div class="card-header" id="filter-heading">
                    <h5 class="mb-0">
                        <button
                            class="btn btn-link col-12"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapse-filter"
                            [attr.aria-expanded]="false"
                            aria-controls="collapse-filter"
                        >
                            <fa-icon class="mx-1 d-inline-block" [icon]="['fas', 'filter']"></fa-icon>
                            <span class="col-10 d-inline-block">Filters</span>
                            <fa-icon class="mx-2 col-1 d-inline-block" [icon]="['fas', 'chevron-down']"></fa-icon>
                        </button>
                    </h5>
                </div>

                <div
                    id="collapse-filter"
                    class="collapse"
                    aria-labelledby="filter-heading"
                    data-bs-parent="#filter-accordion"
                >
                    <div class="card-body">
                        <div class="row gy-2 align-items-center">
                            <div class="col-12 col-sm-auto">
                                <mat-form-field appearance="fill">
                                    <mat-label>Start</mat-label>
                                    <input
                                        matInput
                                        [matDatepicker]="startPicker"
                                        [(ngModel)]="startDate"
                                        (ngModelChange)="onStartChanged()"
                                    />
                                    <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                                    <mat-datepicker #startPicker></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-12 col-sm-auto">
                                <mat-form-field appearance="fill">
                                    <mat-label>End</mat-label>
                                    <input
                                        matInput
                                        [matDatepicker]="endPicker"
                                        [(ngModel)]="endDate"
                                        (ngModelChange)="onEndChanged()"
                                    />
                                    <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                                    <mat-datepicker #endPicker></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-12 col-sm-auto">
                                <mat-form-field appearance="fill">
                                    <mat-label>Schedule Types</mat-label>
                                    <mat-select
                                        multiple
                                        [value]="selectedScheduleTypes()"
                                        (selectionChange)="selectedScheduleTypes.set($event.value)"
                                    >
                                        @for (type of allScheduleTypes; track type.value) {
                                            <mat-option [value]="type.value">{{ type.label }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-12 col-sm-auto">
                                <mat-form-field appearance="fill">
                                    <mat-label>User ID</mat-label>
                                    <input matInput [(ngModel)]="userId" />
                                </mat-form-field>
                            </div>
                            <div class="col-12 col-sm-auto">
                                <mat-form-field appearance="fill">
                                    <mat-label>User name</mat-label>
                                    <input matInput [(ngModel)]="userName" />
                                </mat-form-field>
                            </div>
                            <div class="col-12 col-sm-auto">
                                <mat-form-field appearance="fill">
                                    <mat-label>Bot ID</mat-label>
                                    <input matInput [(ngModel)]="botId" />
                                </mat-form-field>
                            </div>
                            <div class="col-12 col-sm-auto">
                                <mat-form-field appearance="fill">
                                    <mat-label>Bot name</mat-label>
                                    <input matInput [(ngModel)]="botName" />
                                </mat-form-field>
                            </div>
                            <div class="col-12 col-sm-auto d-flex align-items-center">
                                <mat-checkbox
                                    [checked]="returnEmptySessions()"
                                    (change)="returnEmptySessions.set($event.checked)"
                                >
                                    Return empty sessions
                                </mat-checkbox>
                            </div>
                            <div class="col-12 col-sm-auto d-flex align-items-center">
                                <button mat-raised-button color="primary" (click)="search()">Search</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col" class="d-none d-md-table-cell">ID</th>
                                <th scope="col">Scheduled</th>
                                <th scope="col" class="d-none d-md-table-cell">Started</th>
                                <th scope="col" class="d-none d-md-table-cell">Ended</th>
                                <th scope="col" class="d-none d-sm-table-cell">Schedules</th>
                                <th scope="col"></th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (tradingSession of tradingSessions; track tradingSession.id; let i = $index) {
                                <tr>
                                    <th scope="row">{{ page * pageSize + i + 1 }}</th>
                                    <td class="d-none d-md-table-cell">{{ tradingSession.id }}</td>
                                    <td>{{ tradingSession.scheduledStartAtUtc | date: "short" }}</td>
                                    <td class="d-none d-md-table-cell">
                                        {{ tradingSession.startedAtUtc | date: "short" }}
                                    </td>
                                    <td class="d-none d-md-table-cell">
                                        {{ tradingSession.endedAtUtc | date: "short" }}
                                    </td>
                                    <td class="d-none d-sm-table-cell">{{ tradingSession.schedules.join(", ") }}</td>
                                    @if (!tradingSession.isFuture) {
                                        <td>
                                            <button
                                                class="btn btn-primary"
                                                (click)="downloadSessionLogs(tradingSession)"
                                            >
                                                <fa-icon [icon]="['fas', 'floppy-disk']"></fa-icon> Logs
                                            </button>
                                        </td>
                                    }
                                    @if (!tradingSession.isFuture) {
                                        <td
                                            (click)="toggleDetails(tradingSession)"
                                            (keyup.enter)="toggleDetails(tradingSession)"
                                            tabindex="0"
                                            [attr.aria-label]="
                                                tradingSession.isOpenned ? 'Collapse details' : 'Expand details'
                                            "
                                        >
                                            <div class="d-flex justify-content-center align-items-center p-2">
                                                @if (tradingSession.isOpenned) {
                                                    <div>
                                                        <fa-icon [icon]="['fas', 'chevron-up']"></fa-icon>
                                                    </div>
                                                }
                                                @if (!tradingSession.isOpenned) {
                                                    <div>
                                                        <fa-icon [icon]="['fas', 'chevron-down']"></fa-icon>
                                                    </div>
                                                }
                                            </div>
                                        </td>
                                    }
                                </tr>
                                @if (tradingSession.isOpenned) {
                                    <tr>
                                        <td colspan="7">
                                            <div class="trading-session-details">
                                                @if (tradingSession.entries && tradingSession.entries.length > 0) {
                                                    <div class="table-responsive">
                                                        <table class="table table-striped">
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col">#</th>
                                                                    <th scope="col">User</th>
                                                                    <th scope="col">Bot</th>
                                                                    <th scope="col" class="d-none d-sm-table-cell">
                                                                        Started At
                                                                    </th>
                                                                    <th scope="col" class="d-none d-sm-table-cell">
                                                                        Ended At
                                                                    </th>
                                                                    <th scope="col" class="d-none d-md-table-cell">
                                                                        Buy Orders
                                                                    </th>
                                                                    <th scope="col" class="d-none d-md-table-cell">
                                                                        Sell Orders
                                                                    </th>
                                                                    <th scope="col"></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                @for (
                                                                    entry of tradingSession.entries;
                                                                    track $index;
                                                                    let j = $index
                                                                ) {
                                                                    <tr>
                                                                        <th scope="row">{{ j }}</th>
                                                                        <td>{{ entry.userEmail }}</td>
                                                                        <td>{{ entry.botName }}</td>
                                                                        <td class="d-none d-sm-table-cell">
                                                                            {{ entry.start | date: "short" }}
                                                                        </td>
                                                                        <td class="d-none d-sm-table-cell">
                                                                            {{ entry.end | date: "short" }}
                                                                        </td>
                                                                        <td class="d-none d-md-table-cell">
                                                                            {{ entry.purchasedStocks }}
                                                                        </td>
                                                                        <td class="d-none d-md-table-cell">
                                                                            {{ entry.soldStocks }}
                                                                        </td>
                                                                        <td>
                                                                            <button
                                                                                class="btn btn-primary"
                                                                                (click)="
                                                                                    downloadEntryLogs(
                                                                                        tradingSession,
                                                                                        entry
                                                                                    )
                                                                                "
                                                                            >
                                                                                <fa-icon
                                                                                    [icon]="['fas', 'floppy-disk']"
                                                                                ></fa-icon>
                                                                                Logs
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                }
                            }
                        </tbody>
                    </table>
                </div>

                <mat-paginator
                    #paginator
                    class="demo-paginator"
                    (page)="pageChanged($event)"
                    [length]="totalTradingSessions"
                    [pageSize]="pageSize"
                    [disabled]="false"
                    [showFirstLastButtons]="true"
                    [pageSizeOptions]="[5, 10, 15, 25, 100]"
                    [hidePageSize]="false"
                    [pageIndex]="page"
                    aria-label="Select page"
                >
                </mat-paginator>
            </div>
        </div>
    </div>
}
